<template>
    <v-layout column>
        
        <v-progress-linear v-if="bldg && buildingRooms.length==0" class="mt-0 mb-0" color="blue" indeterminate></v-progress-linear>
        <v-card style="height: 270px; padding:5px; background-color: #3f51b522; "
                class="pb-4">
        
        <v-flex v-if="!selectedRoom" xs12 class="subheading pt-3">


            <v-layout align-center justify-center row fill-height class="mt-4 pt-5 headline">
              
                    Room Preview

            </v-layout>

            
        </v-flex>
        <v-flex v-if="selectedRoom" xs12 class="">
            <v-list class="">
                <v-list-tile 
                    v-for="(item, index) in items" 
                    v-if="(item.val !== 'None')"
                    :to="item.to" 
                    :key="index" 
                    class="mb-0 rptile text--lighten-5"    

                    >

                        <v-flex xs3 class="body-2">
                            {{item.label}}
                        </v-flex>

                        <v-flex xs9 class="body-2 mx-2" style="font-weight: 400;">
                            {{item.val}}
                        </v-flex>


                </v-list-tile>
            </v-list>
        </v-flex>
        </v-card>
    </v-layout>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex'

    let RoomPreviewMulti = {

        data() {
          return {
          }
        },

        components: {  },

        computed: {
            ...mapState({
                    bldg: state => state.space.selectedBuilding,
                    selectedRoom: state => state.space.selectedRoom,
                    buildingRooms: state => state.space.buildingRooms,
            }),
            items: function () {
                if (this.selectedRoom && this.bldg) {
                return [
                        { label: 'Number', val: this.selectedRoom.number },
                        { label: 'Floor', val: this.selectedRoom.floor }, 
                        { label: 'Area', val: this.selectedRoom.area + " sf"}, 
                        { label: 'Building', val: this.selectedRoom.bldgAlpha + " - " + this.bldg.name },
                        { label: 'College', val: this.selectedRoom.collegeName + " (" + this.selectedRoom.collegeID + ")" },
                        { label: 'Dept', val: this.selectedRoom.deptName + " (" + this.selectedRoom.deptID + ")" },
                        { label: 'Category', val: this.selectedRoom.categoryName + " (" + this.selectedRoom.category + ")" },
                        { label: 'Use', val: this.selectedRoom.useName + " (" + this.selectedRoom.use + ")" },
                        { label: 'Capacity', val: this.selectedRoom.capacity },
                        { label: 'Class', val: this.selectedRoom.classification},
                    ]
                }
            }
        },

        methods: {
            //...mapActions(['selectBuilding']),
            //...mapMutations([   '',
            //                ]),
        }
    }

    export default RoomPreviewMulti
</script>

<style>

.rptile > .v-list__tile {
    align-items:  flex-start;
    height: auto;
    margin-bottom: 0px;
    color: #404040;
}

</style>



// WEBPACK FOOTER //
// src/components/RoomPreviewMulti.vue